import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import React from 'react'
import './SortableWidgetWrapper.scss'

interface SortableWidgetWrapperProps {
  id: string
  children: React.ReactNode
}

export const SortableWidgetWrapper: React.FC<SortableWidgetWrapperProps> = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  return (
    <div ref={setNodeRef} style={style} className={`sortable-widget-wrapper ${isDragging ? 'is-dragging' : ''}`}>
      <div className="sortable-widget-wrapper__drag-handle" {...attributes} {...listeners}>
        <i className="bi bi-grip-vertical"></i>
      </div>
      <div className="sortable-widget-wrapper__content">{children}</div>
    </div>
  )
}
